import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, Transition } from "@headlessui/react";
import { SortingState } from "@tanstack/react-table";
import { Fragment } from "react";
import { Filter, Search } from "lucide-react";
import TableComponent from "../../../shared/components/table";
import { PanelJoinderRequestColumns } from "../../../shared/components/table/columns/panelJoinderRequestColumns";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import {
  openCaseModal,
  setCaseDetailModal,
} from "../../../states/slices/globalReducer";
import CaseFolderDetailsModal from "./case-folder/modals/CaseFolderDetailsModal";
import { FILTER, NO_DATA } from "../../../assets";

const MOCK_JOINDER_REQUESTS = [
  {
    id: 1,
    sn: 1,
    title:
      "Joinder request for Olugbenga Akintola vs Israel Anyamelu on matter relating to...",
    date_submitted: "05 Nov, 2021 11:54 am",
    appeal_number: "NE/CA/05/22",
    joining_as: "Co-Appellant",
    status: "Submitted",
    requester_name: "Okechukwu Obinna",
  },
];

const FILTERS = ["All cases", "Pending", "Completed"];

function JoinderRequest() {
  const dispatch = useAppDispatch();
  const showCaseFolderDetails = useAppSelector(openCaseModal);

  const [searchTerm, setSearchTerm] = useState("");
  const [sorting, setSorting] = useState<SortingState>([]);
  const [activeFilter, setActiveFilter] = useState(FILTERS[0]);

  const hasData = MOCK_JOINDER_REQUESTS.length > 0;

  const filteredData = MOCK_JOINDER_REQUESTS.filter((item) =>
    item.title.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <div className="flex flex-col w-full h-full">
      <div className="bg-white border-b border-[#E9EAEB] px-8 py-4 flex items-center justify-between">
        <h1 className="text-[28px] font-bold text-[#1A1A1A]">
          Joinder Request
        </h1>

        <Menu as="div" className="relative inline-block text-left">
          <Menu.Button className="inline-flex items-center gap-x-2 rounded-lg border border-[#D0D5DD] bg-white px-3 py-2 text-sm font-medium text-[#344054] shadow-sm hover:bg-gray-50 focus:outline-none">
            <img src={FILTER} alt="filter" className="w-4 h-4" />
            <span>{activeFilter}</span>
          </Menu.Button>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items
              anchor="bottom end"
              className="absolute right-0 z-50 mt-2 w-52 origin-top-right rounded-xl bg-white py-2 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
            >
              <div className="px-1 py-1">
                {FILTERS.map((filter) => (
                  <Menu.Item key={filter}>
                    {({ active }) => (
                      <button
                        onClick={() => setActiveFilter(filter)}
                        className={`${
                          active
                            ? "bg-[#ECFDF3] text-[#027A48]"
                            : "text-[#344054]"
                        } group flex w-full items-center rounded-lg px-3 py-2 text-sm`}
                      >
                        {filter}
                      </button>
                    )}
                  </Menu.Item>
                ))}
              </div>
            </Menu.Items>
          </Transition>
        </Menu>
      </div>

      <div className="flex flex-col flex-1 overflow-hidden">
        <div className="px-8 pt-6 pb-4 flex flex-col gap-y-6">
          <div className="flex items-center gap-x-2 text-sm text-[#475467]">
            <Link
              to="/panel/overview"
              className="cursor-pointer hover:text-[#00B074] transition-colors"
            >
              Home
            </Link>
            <span className="text-[#D0D5DD]">{">"}</span>
            <span className="font-medium text-[#1A1A1A]">Joinder Request</span>
          </div>

          <div className="w-full max-w-[300px] relative">
            <input
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-10 pr-4 py-2.5 border border-[#D0D5DD] rounded-lg text-sm placeholder:text-[#667085] focus:outline-none focus:border-[#00B074] focus:ring-1 focus:ring-[#00B074] shadow-sm bg-white"
            />
            <Search className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#667085]" />
          </div>
        </div>

        <div className="flex-1 px-8 pb-8">
          {hasData ? (
            <div className="bg-white overflow-hidden">
              <TableComponent
                DATA={filteredData}
                // @ts-ignore
                COLUMNS={PanelJoinderRequestColumns}
                sorting={sorting}
                setSorting={setSorting}
              />
              <div className="flex items-center justify-between px-6 py-3 border-t border-[#E9EAEB] text-sm text-[#667085]">
                <span>
                  Showing <span className="font-medium">1</span> of{" "}
                  <span className="font-medium">{filteredData.length}</span>{" "}
                  entries
                </span>
                <span>Page 1 of 1</span>
              </div>
            </div>
          ) : (
            <div className="h-full flex flex-col items-center justify-center gap-y-4">
              <img
                src={NO_DATA}
                alt="No data"
                className="w-[120px] h-[120px]"
              />
              <p className="text-[#667085] text-sm">
                There are no joinder requests at the moment.
              </p>
            </div>
          )}
        </div>
      </div>

      <CaseFolderDetailsModal
        open={showCaseFolderDetails || false}
        close={() => dispatch(setCaseDetailModal(false))}
      />
    </div>
  );
}

export default JoinderRequest;
